import { useAuth } from "@/contexts/auth/useAuth";
import { UserDropdown } from "./UserDropdown";
import { NotificationsDropdown } from "./NotificationsDropdown";
import { ThemeToggle } from "./ThemeToggle";
import { RoleSwitch } from "@/components/auth/RoleSwitch";
import React, { useState } from "react";
import { NewOvertimeRequestModal } from "@/components/overtime/NewOvertimeRequestModal";
import { UserRole } from "@/types/enums";

export function TopNavbar({ pageTitle }: { pageTitle: string }) {
  const { user } = useAuth();
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <header className="sticky top-0 z-10 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="flex h-16 items-center px-4 md:px-6">
        <div className="flex-1">
          <h1 className="font-bold text-2xl text-foreground">{pageTitle}</h1>
        </div>
        <div className="flex items-center space-x-2">
          <RoleSwitch />
          {/* + New Overtime button for authorized roles */}
          {user && [
            UserRole.DEPARTMENT_HEAD,
            UserRole.SUPERINTENDENT,
            UserRole.PLANT_MANAGER,
            UserRole.SUPER_ADMIN,
            UserRole.APP_OWNER,
          ].includes(user.role as UserRole) && (
            <>
              <button
                type="button"
                className="ml-2 px-4 py-2 rounded-2xl bg-primary text-primary-foreground shadow-md text-sm font-semibold hover:bg-primary/90 transition"
                onClick={() => setModalOpen(true)}
              >
                <span className="mr-2">+</span>New Overtime
              </button>
              <NewOvertimeRequestModal
                open={modalOpen}
                onOpenChange={setModalOpen}
                userRole={user.role}
                userDepartment={user.department ? [user.department] : []}
                companyId={user.companyId}
              />
            </>
          )}
          <ThemeToggle />
          <NotificationsDropdown />
          <UserDropdown />
        </div>
      </div>
    </header>
  );
}

export default TopNavbar;
